var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOwner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#FFFFFF",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2397 5104 c-270 -49 -502 -203 -658 -438 -69 -105 -114 -215 -141 -346 -17 -85 -19 -126 -16 -385 4 -263 7 -297 27 -370 133 -474 578 -783 1054 -734 366 38 673 265 821 609 58 135 68 202 73 481 4 206 2 277 -11 359 -57 362 -315 669 -661 787 -152 52 -331 65 -488 37z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2352 2609 c-59 -29 -92 -88 -92 -161 0 -47 6 -64 40 -116 96 -149 95 -142 69 -437 l-22 -250 63 -173 c73 -198 90 -222 156 -222 71 0 86 22 160 223 l65 178 -25 215 c-14 119 -26 230 -26 247 0 54 19 104 66 174 64 96 74 117 74 162 0 51 -15 89 -48 124 -50 53 -66 57 -259 57 -161 0 -182 -2 -221 -21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1510 2391 c-239 -92 -457 -175 -483 -185 -72 -27 -140 -86 -171 -147 l-26 -53 0 -983 c0 -970 0 -983 20 -1003 20 -20 33 -20 1704 -20 1643 0 1684 0 1707 19 l24 19 0 974 0 973 -22 40 c-37 69 -92 112 -204 161 -57 25 -281 120 -497 211 -349 148 -395 165 -417 155 -14 -7 -30 -22 -35 -34 -5 -13 -124 -488 -264 -1055 -141 -568 -260 -1052 -267 -1075 -11 -42 -19 -12 -274 1002 -145 575 -268 1064 -274 1088 -13 48 -42 82 -68 81 -10 0 -214 -76 -453 -168z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOwner);
export default __webpack_public_path__ + "static/media/owner.c33a818a2d60a12c99bc327313fcd99a.svg";
export { ForwardRef as ReactComponent };